import * as React from "react";
import { SVGProps } from "react";
const SvgSolarPanel = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m23.858 14 .57 4h-4.135l-.233-4h3.798Zm-5.8 0 .233 4H13.71l.233-4h4.115Zm-6.118 0-.233 4H7.571l.571-4h3.798Zm5.767-6 .233 4h-3.88l.233-4h3.414Zm-5.416 0-.233 4h-3.63L9 8h3.291ZM23 8l.571 4h-3.629l-.233-4H23Zm-3 12H5.011L7.01 6h17.98l1.999 14H20Zm6.848-15.142A1.001 1.001 0 0 0 25.857 4H6.143c-.498 0-.92.366-.991.858l-2.285 16A1 1 0 0 0 3.857 22H12v2h-1a1 1 0 0 0 0 2h10a1 1 0 0 0 0-2h-1v-2h8.143a1 1 0 0 0 .99-1.142l-2.285-16Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSolarPanel;
